import { Enemy } from "./Enemy";
import { Engine } from "../Engine";
import { GameConstants } from "../GameConstants";
import { MathUtils } from "../utils/MathUtils";

export class WindEnemy extends Enemy {

    public improving: boolean;

    private f: number;

    constructor (subtype: string, creationTick: number, engine: Engine, path: {r: number, c: number}[], l?: number, splitted?: boolean) {
        
        super(GameConstants.ENEMY_WIND, subtype, creationTick, engine, path, l, splitted);

        // para que no se paren todos en el mismo lugar y al mismo tiempo
        this.f = GameConstants.WIND_IMPROVING_TICKS - creationTick % GameConstants.WIND_IMPROVING_TICKS;

        this.improving = false;
    }

    public update(): void {

        this.f ++;

        super.update();

        if (this.improving) {

            this.improve();

            if (this.f >= this.enemyData.speedBoostTicks) {
                this.f = 0;
                this.improving = false;
            }

        } else {

            

            // no cura si ya esta muy cerca de la salida
            if (this.f >= GameConstants.WIND_IMPROVING_TICKS) {
                this.f = 0;
                this.improving = true;
            }
        }
    }

    private improve(): void {

        // encontrar a todos los enemigos que esten dentro de un determinado radio y restaurarles la salud
        for (let i = 0; i < this.engine.enemies.length; i ++) {

            const enemy = this.engine.enemies[i];

            if (enemy.id === this.id) {
                // se cura a si mismo
                enemy.improveSpeed(this.enemyData.speedBoostMult);
            } else {
                const distanceSquare = MathUtils.fixNumber((enemy.x - this.x) * (enemy.x - this.x) + (enemy.y - this.y) * (enemy.y - this.y));
                if (distanceSquare <= this.enemyData.speedBoostRadius * this.enemyData.speedBoostRadius) {
                    enemy.improveSpeed(this.enemyData.speedBoostMult);
                }
            }
        }
    }
}